export const UI_INVALID_PHONE_NUMBER_ERROR: string = 'invalidPhoneNumber';
